import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import DocumentHead from 'legacyComponents/documentHead';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';

import { clientStore } from 'apps/client/app';
import { InitiativeProjectsManager } from 'apps/initiative/tabs/projects/appManager';

@withNamespaces()
@observer
export class InitiativeProjectsTab extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new InitiativeProjectsManager(
      this.props.initiativeManager,
      this.props,
    );
  }

  render() {
    const { initiativeManager } = this.props;
    const { initiative } = initiativeManager;
    const {
      title,
      canUpdate,
      inSpace: { whichTypes },
    } = initiative;

    const projects = this.appManager.projectsConn.arrayApp;
    return (
      <MainWrapper>
        <DocumentHead title={`${title} - Projects`} />
        <CardSection
          title='All Projects'
          tooltip='Create new project'
          createHandler={
            whichTypes.includes('Space')
              ? () => clientStore.routerStore.navigate('home.newProject')
              : ''
          }
          owner={canUpdate}
          ownerName={title}
          cardApp={projects}
          CardComponent={ProjectCard}
          noDataCardType='project'
          last
          noCount
          initiative
          gridColumns={3}
        />
      </MainWrapper>
    );
  }
}

InitiativeProjectsTab.propTypes = {
  initiativeManager: PropTypes.object,
  params: PropTypes.object,
  routeName: PropTypes.string,
  t: PropTypes.func,
};
